module.exports = __webpack_public_path__ + "static/img/wap_signin_logo_zysj.b3b133e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys/login/wap_signin_logo_zysj.png
// module id = SKd3
// module chunks = 1